<script lang="ts" setup>
import { mdiChevronRight } from "@mdi/js";
import Icon from "~/components/ui/Icon.vue";
import t from "~/utils/translate";

interface Props {
	inputClass?: string;
	wrapperClass?: string;
}

withDefaults(defineProps<Props>(), {
	wrapperClass: "p-1.5",
});

const router = useRouter();
const { trackClickDarkly, isHomePage } = useHomePage();

const bookingCode = ref("");

const submitCode = () => {
	if (bookingCode.value) {
		window.location.href = `/book-a-bet-results?bookingCode=${bookingCode.value.trim()}`;
	} else {
		router.push("/book-a-bet-results");
	}
	isHomePage.value && trackClickDarkly("/book-a-bet");
};
</script>

<template>
	<div :class="['bg-light-300 dark:bg-dark-700 rounded-xl w-full flex gap-2 justify-between', wrapperClass]">
		<form class="flex flex-1 relative" @submit.prevent="submitCode()">
			<input
				v-model="bookingCode"
				:class="[
					'outline-none rounded-lg h-10 w-full pl-3 pr-10 border border-light-500 dark:border-dark-500 placeholder:text-dark-700 dark:placeholder:text-light-50',
					inputClass ? inputClass : 'bg-light-50 dark:bg-dark-800',
				]"
				:placeholder="t('enter-booking-code')"
				@submit="submitCode()"
			/>
			<div
				@click="submitCode()"
				class="w-7 h-7 rounded bg-primary-500 absolute right-2 top-1/2 -translate-y-1/2 cursor-pointer flex items-center justify-center"
			>
				<Icon :path="mdiChevronRight" class="fill-light-50 w-5 h-5" />
			</div>
		</form>
		<!-- All Codes -->
		<NuxtLink
			to="/book-a-bet-results"
			@click="isHomePage && trackClickDarkly('/book-a-bet')"
			:class="[
				'flex items-center text-sm rounded-lg px-3 h-10 text-dark-700 dark:text-light-50 hover:text-dark-700 dark:hover:text-light-50',
				inputClass ? inputClass : 'bg-light-50 dark:bg-dark-800',
			]"
		>
			{{ t("all-codes") }} <Icon class="w-5 h-5 fill-dark-700 dark:fill-light-50" :path="mdiChevronRight" />
		</NuxtLink>
	</div>
</template>

<!-- <template>
	<div
		class="relative flex items-center w-full h-8 px-2 py-2 text-xs font-bold rounded-t-lg cursor-pointer md:text-base bg-dark-800 text-light-50 dark:bg-dark-700 hover:text-light-50"
		@click="router.push({ path: '/book-a-bet-results' })"
	>
		{{ t("booking-code") }}
		<UiIcon :path="mdiChevronRight" class="absolute w-6 h-6 -translate-y-1/2 fill-light-50 right-2 top-1/2" />
	</div>
	<div class="flex flex-row w-full mb-1 overflow-x-scroll overflow-y-scroll scrollbar-hidden">
		<form class="w-full m-1 text-xs" @submit.prevent="submitCode()">
			<UiFormInput
				class="w-full text-xs"
				id="book-a-bet-search"
				v-model="bookingCode"
				:iconPos="'right'"
				:label="t('enter-booking-code')"
				:unwrap-error="true"
				labelClass="rounded-[4px]"
				no-floating-label
			/>
		</form>
		<div @click="submitCode()" class="flex m-1 items-center justify-center flex-shrink-0 w-10 h-10 rounded-[4px] cursor-pointer bg-identity">
			<UiIcon class="w-6 h-6 fill-light-50" :path="mdiChevronRight"></UiIcon>
		</div>
	</div>
</template> -->
